import React from 'react';
import { Box, Icon, InlineMessage, Typography } from '@saviynt/design-system';

import './MoreRecordsMessage.css';

const msgs = {
  moreRecordsMessageTitle: {
    id: 'pam.landingPage.moreRecords.title',
    defaultMessage: 'Too many assets to show.',
  },
  moreRecordsMessageDescription: {
    id: 'pam.landingPage.moreRecords.description',
    defaultMessage:
      'To find the available assets you need, type in the search bar and use filters.',
  },
  // JIT for Apps (JFA)
  moreRecordsMessageTitleJfa: {
    id: 'pam.landingPage.moreRecords.titleJfa',
    defaultMessage: 'Too many roles to show.',
  },
  moreRecordsMessageDescriptionJfa: {
    id: 'pam.landingPage.moreRecords.descriptionJfa',
    defaultMessage:
      'To find the available roles you need, type in the search bar and use filters.',
  },
};

// eslint-disable-next-line react/prop-types
function MoreRecordsMessage({ localize, isJitForApps }) {
  // localize param is instance of the useLocalize hook.
  const moreRecordsMessage = isJitForApps
    ? localize(msgs.moreRecordsMessageTitleJfa)
    : localize(msgs.moreRecordsMessageTitle);

  const moreRecordsDescription = isJitForApps
    ? localize(msgs.moreRecordsMessageDescriptionJfa)
    : localize(msgs.moreRecordsMessageDescription);

  return (
    <Box className='MoreRecordsMessage'>
      <InlineMessage
        leftIcon={<Icon kind='alertCriticalOutline' />}
        className='MoreRecordsMessage'>
        <div className='MoreRecordsMessage-text'>
          <Typography kind='h4'>{moreRecordsMessage}</Typography>
          <Typography kind='body2'>{moreRecordsDescription}</Typography>
        </div>
      </InlineMessage>
    </Box>
  );
}

export default MoreRecordsMessage;
